import { gql } from "graphql-tag"

const DELETE_VENDOR = gql`
  mutation deleteVendor($id: ID!) {
    deleteVendor(id: $id) {
      status
    }
  }
`

export default DELETE_VENDOR
